import {Property} from '@mintdata/mint-kit/api/decorators/Property';
import {ColorWithVisibility} from '@mintdata/mint-kit/api/models/ColorWithVisibility';
import {PositiveUnits} from '@mintdata/mint-kit/api/models/PositiveUnits';
import {Units} from '@mintdata/mint-kit/api/models/Units';
import {BeanConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/BeanConfig';
import {PositiveUnitsConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/PositiveUnitsConfig';
import {UnitsConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/UnitsConfig';

export class TextShadow
{
    @Property<ColorWithVisibility>({
        title: 'Color',
        tip: `Color`,
        isRequired: true,
        typeConfig: BeanConfig,
        typeCtor: ColorWithVisibility
    })
    public color:ColorWithVisibility;

    @Property<Units>({
        title: 'Delta X',
        tip: `Delta X`,
        isRequired: true,
        typeConfig: UnitsConfig,
        typeCtor: Units
        // binding: BindingConfig.with('@fontSize[0]', BindingIconPlace.CenterTop, BindingTooltipPlace.Top)
    })
    public deltaX:Units;

    @Property<Units>({
        title: 'Delta Y',
        tip: `Delta Y`,
        isRequired: true,
        typeConfig: UnitsConfig,
        typeCtor: Units
        // binding: BindingConfig.with('@fontSize[0]', BindingIconPlace.CenterTop, BindingTooltipPlace.Top)
    })
    public deltaY:Units;

    @Property<PositiveUnits>({
        title: 'Blur',
        tip: `Blur`,
        isRequired: true,
        typeConfig: PositiveUnitsConfig,
        typeCtor: PositiveUnits
        // binding: BindingConfig.with('@fontSize[0]', BindingIconPlace.CenterTop, BindingTooltipPlace.Top)
    })
    public blur:PositiveUnits;

    public constructor(color:ColorWithVisibility,
                       deltaX:Units,
                       deltaY:Units,
                       blur:PositiveUnits)
    {
        this.color = color;
        this.deltaX = deltaX;
        this.deltaY = deltaY;
        this.blur = blur;
    }

    public static default():TextShadow
    {
        return new TextShadow(
            ColorWithVisibility.fromHexAlpha('#000000', .5, false),
            Units.fromPixels(1),
            Units.fromPixels(1),
            PositiveUnits.fromPixels(2),
        );
    }

    public static none():TextShadow
    {
        return new TextShadow(
            ColorWithVisibility.fromHexAlpha('#000000', .5, false),
            Units.fromPixels(0),
            Units.fromPixels(0),
            PositiveUnits.fromPixels(0),
        );
    }

    public toCssString():string
    {
        return `${this.deltaX.toCssString()} ${this.deltaY.toCssString()} ${this.blur.toCssString()} ${this.color.toCssString()}`;
    }

}
